export default "__VITE_ASSET__DXzTdnBf__"